// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1ePNy","header":"ClearentDisclaimer_header__qBgeT","inner":"ClearentDisclaimer_inner__LoV1o"};